/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.apiFetch();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
  timber.accordion();
  timber.slickSlider();
  window.objectFitImages();
  timber.onlineDemoModal();
  timber.disclosuresInit();
  timber.ctaBlocks();
  timber.tabs();
  timber.stickyNav();
  timber.lightGallery();
  timber.mobileTabs();
  timber.productDropdown();
  // timber.hideAndSeek();
  // timber.easter();
};

timber.easter = function () {
  var $modal = $('#hide-and-seek-modal');
  const modalTrigger = document.querySelector('.js-modal-trigger');

    // if modalTrigger is clicked add class to modal
    modalTrigger.addEventListener('click', () => {
      $modal.addClass('modal--active');
    });

    $modal.find('.modal__close, .modal__va-m').click(function(e) {
      if ($(e.target).is('a')) {
        return true;
      }

      if (
        $(e.target).hasClass('modal__content') ||
        $(e.target).parents('.modal__content').length !== 0
      ) {
        return false;
      }

      $modal.removeClass('modal--active');
    });

    function setCookie(cname,cvalue,exdays) {
      const d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      let expires = "expires=" + d.toGMTString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    let cookie = getCookie("easter-start");

    if (cookie == "") {

      setTimeout(function() {
        $modal.addClass('modal--active');
      }, 2000);

      setCookie("easter-start", true, 1);

    }

};

timber.hideAndSeek = function () {
  function setCookie(cname,cvalue,exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  let cookie = getCookie("easter-start");
  var closeButton = $('.js-modal-close-button');

  if (cookie == "") {
    var $modal = $('#easter-start-modal');

    setTimeout(function() {
      $modal.addClass('modal--active');
    }, 2000);

    setCookie("easter-start", true, 1);

    $modal.find('.modal__close, .modal__va-m').click(function(e) {
      if ($(e.target).is('a')) {
        return true;
      }

      if ($(e.target).hasClass('modal__content') || $(e.target).parents('.modal__content').length !== 0) {
        return false;
      }

      $modal.removeClass('modal--active');
    });

    closeButton.click(function(e) {
      $modal.removeClass('modal--active');
    });

  }

  // Find easter eggs
  const normalAlreadyFound = localStorage.getItem('getNormalEgg');
  const easterCompleteModal = $('#easter-complete-modal');
  console.log(normalAlreadyFound)

  if (!normalAlreadyFound) {
    $('.js-hide-and-seek-item').each(function() {
      var $egg = $(this);
      $egg.on('click', function () {
        $('.js-hide-and-seek-item').hide();
        localStorage.setItem('getNormalEgg', true);

        easterCompleteModal.addClass('modal--active');

        easterCompleteModal.find('.modal__close, .modal__va-m').click(function(e) {
          if ($(e.target).is('a')) {
            return true;
          }

          if ($(e.target).hasClass('modal__content') || $(e.target).parents('.modal__content').length !== 0) {
            return false;
          }

          easterCompleteModal.removeClass('modal--active');
        });

      })
    });
  } else {
    $('.js-hide-and-seek-item').hide();
  }
};

timber.productDropdown = function () {
  var $productDropdown = $('.js-product-dropdown');

  function formatTemplateResult (state) {
    var $element = $(state.element);
    var options = $element.data('options');

    if (options && options.length) {
      var image = options[0].image;
      var description = options[0].description;
      var stock = options[0].stock;
      var $template = $('.js-product-dropdown-template-result').clone()

      console.log(image);
      console.log(description);
      console.log(stock);
      console.log($template);

      $template.find('.product-dropdown__title').text(state.text);
      if (image) $template.find('.product-dropdown__image img').attr('src', image);
      if (description) $template.find('.product-dropdown__description').html(description);
      if (stock) $template.find('.product-dropdown__stock').append($(stock));

      return $template.children();
    }

    return state.text;
  }

  function formatTemplateSelection (state) {
    var $template = $('.js-product-dropdown-template-selection').clone().children();

    if ($template.length) {
      return $template;
    }

    return state.text;
  }

  if ($productDropdown.length) {
    $productDropdown.on('select2:select', function (e) {
      window.location.href = e.params.data.id;
    });

    var disabled = false;
    var optionsCount = $productDropdown.find('option').length;
    if (optionsCount === 1) {
      disabled = true;
    }

    $productDropdown.select2({
      dropdownCssClass: 'product-dropdown__container',
      minimumResultsForSearch: Infinity,
      templateResult: formatTemplateResult,
      templateSelection: formatTemplateSelection,
      disabled: disabled
    });
  }
};

timber.mobileTabs = function () {
  var $tabs = $('.mobile-nav__tab-content');
  var $links = $('.js-mobile-tab-trigger');
  var linkActiveClass = 'mobile-nav__tabs-link--active';

  $links.click(function(e) {
    e.preventDefault();

    var $this = $(e.currentTarget);
    var $target = $($this.attr('href'));

    $links.removeClass(linkActiveClass);
    $this.addClass(linkActiveClass);

    $tabs.hide();
    $target.show();
  });
}

timber.ctaBlocks = function () {
  $('.cta-block').hover(
    function(e) {
      var content = e.currentTarget.querySelector('.cta-block__body');
      content.style.height = `${content.scrollHeight}px`;
    }, function(e) {
      var content = e.currentTarget.querySelector('.cta-block__body');
      content.style.height = 0;
    }
  );
};

timber.lightGallery = function () {
  const trigger = document.querySelector('.js-lightgallery-trigger');

  lightGallery(document.getElementById('articles-lightgallery'));

  if (trigger && window.galleryImages) {
    trigger.addEventListener('click', e => {
      e.preventDefault();

      const currentThumb = document.querySelector('.product-single__thumbnail.active');
      const currentThumbIndex = parseInt(currentThumb.dataset.index, 10);

      // eslint-disable-next-line no-undef
      lightGallery(trigger, {
        index: currentThumbIndex,
        counter: false,
        download: false,
        dynamic: true,
        dynamicEl: window.galleryImages,
      });
    });
  }
};

timber.tabs = function () {
  var activeClass = 'tabs__list-link--active';

  $('.tabs').each(function() {
    var $this = $(this);
    var $links = $this.find('.tabs__list-link');
    var $content = $this.find('.tabs__content');

    $links.click(function(e) {
      e.preventDefault();
      $links.removeClass(activeClass);
      $content.slideUp('slow');

      var $link = $(e.currentTarget);
      $link.addClass(activeClass);

      $($link.attr('href')).slideDown('slow');
    });

    $content.each(function() {
      var $content = $(this);
      var $button = $content.find('a:contains(review)').last();
      if ($button.length === 0) {
        $button = $content.find('a[href*="blog.misterbarish.fr"],a[href*="misterbarish.be"]').last();
      }

      $button.remove();
      $content.append($button);
      $button.addClass('tabs__button-overlay');
      $button.attr('target', '_blank');
      $button.attr('rel', 'noopener');
    })
  });
};

timber.stickyNav = function () {
  var $stickyNav = $('.sticky-nav');
  var $links = $('.sticky-nav__list-link');
  var linkActiveClass = 'sticky-nav__list-link--active';
  var $body = $('html, body');
  var $navSections = $('.js-nav-section');
  var isNavigating = false;
  var $productForm = $('.js-main-add-to-cart-form');

  if ($stickyNav.length === 0) {
    return false;
  }

  $('.js-trigger-add-to-cart').click(function(e) {
    e.preventDefault();
    $productForm.submit();
  });

  $links.click(function(e) {
    e.preventDefault();

    var $this = $(e.currentTarget);
    var $target = $($this.attr('href'));

    $links.removeClass(linkActiveClass);
    $this.addClass(linkActiveClass);
    isNavigating = true;

    $body.stop().animate({
      scrollTop: $target.offset().top - 20
    }, 500, function() {
      isNavigating = false;
    });
  });

  $navSections.waypoint({
    handler: function() {
      if (!isNavigating) {
        $links.removeClass(linkActiveClass)
          .filter('[href="#' + this.element.id + '"]')
          .addClass(linkActiveClass);
      }
    }
  }, {
    offset: '100%'
  });
};

timber.slickSlider = function () {
  $('.horizontal-slider').each(function() {
    var $this = $(this);
    var $slider = $this.find('.horizontal-slider__slick');
    var $nav = $this.find('.horizontal-slider__nav');

    $slider.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      appendArrows: $nav,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  });

  $('.horizontal-slider-small').each(function() {
    var $this = $(this);
    var $slider = $this.find('.horizontal-slider__slick');
    var $nav = $this.find('.horizontal-slider__nav');

    $slider.slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      appendArrows: $nav,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
  });

  $('.horizontal-slider-accessories').each(function() {
    var $this = $(this);
    var $slider = $this.find('.horizontal-slider__slick');
    var $nav = $this.find('.horizontal-slider__nav');

    $slider.slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      appendArrows: $nav,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
  });

  $('.horizontal-slider-thumbs').each(function() {
    var $this = $(this);
    var $slider = $this.find('.horizontal-slider__slick');
    var $nav = $this.find('.horizontal-slider__nav');

    $slider.slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      appendArrows: $nav,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }
      ]
    });
  });

  $('.blog-product-slider').each(function() {
    var $this = $(this);
    var $slider = $this.find('.blog-product-slider__slick');

    $slider.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      dots: true,
	    arrows: false
    });
  });
};

timber.onlineDemoModal = function() {

  function setCookie(cname,cvalue,exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }


  // if (window.enableOnlineDemoModal) {

  //   let cookie = getCookie("demo");
  //   console.log(cookie);

  //   if (cookie == "") {
  //     var $modal = $('#demo-modal');

  //     setTimeout(function() {
  //       $modal.addClass('modal--active');
  //     }, 6000);

  //     setCookie("demo", true, 1);

  //     $modal.find('.modal__close, .modal__va-m').click(function(e) {
  //       if ($(e.target).is('a')) {
  //         return true;
  //       }

  //       if ($(e.target).hasClass('modal__content') || $(e.target).parents('.modal__content').length !== 0) {
  //         return false;
  //       }

  //       $modal.removeClass('modal--active');
  //     });
  //   }
  // }

}

timber.disclosuresInit = function() {
  timber.DisclosureEls = new timber.Disclosures();
}

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  
    timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
      'onDrawerOpen': ajaxCart.load
    });
  
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.apiFetch = function () {
  var truncate = function (text) {
    var string = text.substring(0, 120);
    if (text.length > 120) {
      string += '&hellip;'
    }

    return string;
  };

  $('.js-api-fetch').each(function() {
    var $this = $(this);
    var api = $this.data('api');
    var limit = $this.data('limit'); // optional limitation
    var itemClass = $this.data('item-class');

    $.ajax({
      url: api,
      data: {},
      dataType: 'jsonp',
      success: function(data) {
        if (data) {
          // get length of files
          var length = limit ? limit : data.length;
          var items = '';

          for (var i = 0; i < length; i++) {
            var el = data[i];
            items += '<div class="' + itemClass + '">' +
              '<a href="' + el.url + '" target="_blank" class="social-item-link">' +
                '<img src="' + el.photo + '" class="social-item-link__image" />' +
                '<span class="social-item-link__content"><span class="social-item-link__text">' +
                  truncate(el.text) +
                '</span></span>' +
              '</a>' +
            '</div>';
          }

          $this.html(items);
        }
      }
    });
  });
};

timber.accordion = function () {
  $('.accordion__title').click(function(e) {
    e.preventDefault();
    $(this).toggleClass('active').next('.accordion__content').toggle('fast');
  });
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');

  if (variant) {


    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html(window.translations.add_to_cart);
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html(window.translations.sold_out);
      $quantityElements.hide();
    }

    $addToCart.attr('data-variant-sku', variant.sku);

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html('<s>' + Shopify.formatMoney(variant.compare_at_price, moneyFormat) + '</s>')
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html(window.translations.unavailable);
    $quantityElements.hide();
  }
};



timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    $(timber.cache.$thumbImages[0]).addClass('active');

    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      $('.product-single__thumbnail.active').removeClass('active');
      $(this).addClass('active');
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
 if (timber.cache.$changeView.length) {
   timber.cache.$changeView.on('click', function() {
     var view = $(this).data('view'),
         url = document.URL,
         urlWithoutHash = url.split('#')[0],
         hasParams = url.indexOf('?') > -1,
         location = '';

     if (hasParams) {
       location = replaceUrlParam(urlWithoutHash, 'view', view);
     } else {
       location = urlWithoutHash + '?view=' + view;
     }

     if(url.indexOf('#') > -1) {
       var hash = url.substring(url.indexOf('#')+1);
       location += '#' + hash;
     }

     window.location = location;
   });
 }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    timber.cache.$body.trigger('beforeDrawerOpen.timber', this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));

    // Notify the drawer has opened
    timber.cache.$body.trigger('afterDrawerOpen.timber', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // Notify the drawer is going to close
    timber.cache.$body.trigger('beforeDrawerClose.timber', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');

    // Notify the drawer is closed now
    timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

/*============================================================================
  Disclosure modules
  - Source https://gist.github.com/benkovy/af523d2604560546b02494a9379a53be
==============================================================================*/
timber.Disclosures = (function() {
  var selectors = {
    disclosureList: '[data-disclosure-list]',
    disclosureToggle: '[data-disclosure-toggle]',
    disclosureInput: '[data-disclosure-input]',
    disclosureOptions: '[data-disclosure-option]'
  };

  var classes = {
    listVisible: 'disclosure-list--visible'
  };

  var Disclosure = function () {
    this.$container = $('.disclosure');
    this.cache = {};
    this.cacheSelectors();
    this.connectOptions();
    this.connectToggle();
    this.onFocusOut();
  };

  Disclosure.prototype.cacheSelectors = function() {
    this.cache = {
      $disclosureList: this.$container.find(selectors.disclosureList),
      $disclosureToggle: this.$container.find(selectors.disclosureToggle),
      $disclosureInput: this.$container.find(selectors.disclosureInput),
      $disclosureOptions: this.$container.find(selectors.disclosureOptions)
    };
  },

  Disclosure.prototype.connectToggle = function() {
    this.cache.$disclosureToggle.on(
      'click',
      function(evt) {
        var ariaExpanded =
          $(evt.currentTarget).attr('aria-expanded') === 'true';
        $(evt.currentTarget).attr('aria-expanded', !ariaExpanded);

        this.cache.$disclosureList.toggleClass(classes.listVisible);
      }.bind(this)
    );
  },

  Disclosure.prototype.connectOptions = function() {
    this.cache.$disclosureOptions.on(
      'click',
      function(evt) {
        evt.preventDefault();
        this.submitForm($(evt.currentTarget).data('value'));
      }.bind(this)
    );
  },

  Disclosure.prototype.onFocusOut = function() {
    this.cache.$disclosureToggle.on(
      'focusout',
      function(evt) {
        var disclosureLostFocus =
          this.$container.has(evt.relatedTarget).length === 0;

        if (disclosureLostFocus) {
          this.hideList();
        }
      }.bind(this)
    );

    this.cache.$disclosureList.on(
      'focusout',
      function(evt) {
        var childInFocus =
          $(evt.currentTarget).has(evt.relatedTarget).length > 0;
        var isVisible = this.cache.$disclosureList.hasClass(
          classes.listVisible
        );

        if (isVisible && !childInFocus) {
          this.hideList();
        }
      }.bind(this)
    );

    this.$container.on(
      'keyup',
      function(evt) {
        // escape
        if (evt.which !== 27) return;
        this.hideList();
        this.cache.$disclosureToggle.focus();
      }.bind(this)
    );

    $('body').on(
      'click',
      function(evt) {
        var isOption = this.$container.has(evt.target).length > 0;
        var isVisible = this.cache.$disclosureList.hasClass(
          classes.listVisible
        );

        if (isVisible && !isOption) {
          this.hideList();
        }
      }.bind(this)
    );
  },

  Disclosure.prototype.submitForm = function(value) {
    console.log(value);
    this.cache.$disclosureInput.val(value);
    this.$container.parents('form').submit();
  },

  Disclosure.prototype.hideList = function() {
    this.cache.$disclosureList.removeClass(classes.listVisible);
    this.cache.$disclosureToggle.attr('aria-expanded', false);
  },

  Disclosure.prototype.unload = function() {
    this.cache.$disclosureOptions.off();
    this.cache.$disclosureToggle.off();
    this.cache.$disclosureList.off();
    this.$container.off();
  }

  return Disclosure;
})();

// Initialize Timber's JS on docready
$(timber.init);
